import clsx from "clsx";
import React, { useState, memo, useEffect } from "react";

interface IBlurImage {
  height?: number | string;
  width?: number | string;
  src?: string;
  objectFit?: string;
  className?: string;
  alt?: string;
  [x: string]: any;
}

// Use memo to prevent unnecessary re-renders
export const BlurImage = memo(({
  height,
  width,
  src,
  className,
  objectFit,
  alt,
  ...rest
}: IBlurImage) => {
  const [isLoading, setLoading] = useState(true);
  
  // Reset loading state when src changes
  useEffect(() => {
    setLoading(true);
  }, [src]);
  
  const handleImageLoad = () => {
    setLoading(false);
  };

  // Add error handling
  const handleImageError = () => {
    setLoading(false);
  };

  return (
    <img
      className={clsx(
        "transition duration-300 transform",
        isLoading ? "blur-sm scale-105" : "blur-0 scale-100",
        className
      )}
      onLoad={handleImageLoad}
      onError={handleImageError}
      src={src}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      style={{ objectFit: objectFit || 'cover' }}
      alt={alt || "Image"}
      {...rest}
    />
  );
});
